import React from 'react';
import styles from '@dazn/lp-web/src/components/VideoBanner/video-banner.module.css';
import {deviceDetector} from '@dazn/lp-web/src/utils/deviceDetector';
import {
    ExitFullscreenIcon,
    FullScreenIcon,
    MutedSpeakerIcon,
    PauseIcon,
    PlayButtonIcon,
    SpeakerIcon
} from '@dazn/lp-web/src/components/Icons';
import {useVideoBannerContext} from '@dazn/lp-web/src/components/VideoBanner/VideoBannerContext';
import {useVideoBannerPlayer} from '@dazn/lp-web/src/components/VideoBanner/useVideoBannerPlayer';

export const VideoControls = () => {
    const {isPlaying, isFullScreen, isMuted, currentTime, totalDuration} =
        useVideoBannerContext();
    const {toggleFullScreen, togglePlayPause, toggleMuteUnmute} =
        useVideoBannerPlayer();
    return (
        <div className={styles.buttonSections}>
            <div className={styles.buttonSectionsColumn}>
                {!deviceDetector.isPhoneOnlyDevice && (
                    <div onClick={togglePlayPause}>
                        {isPlaying ? <PauseIcon /> : <PlayButtonIcon />}
                    </div>
                )}
                <div onClick={toggleMuteUnmute}>
                    {isMuted ? <MutedSpeakerIcon /> : <SpeakerIcon />}
                </div>
            </div>

            <div className={styles.buttonSectionsColumn}>
                {totalDuration && (
                    <div className={styles.videoTime}>
                        {currentTime}
                        <span>/{totalDuration}</span>
                    </div>
                )}
                {!deviceDetector.isPhoneOnlyDevice && (
                    <div onClick={toggleFullScreen}>
                        {isFullScreen ? (
                            <ExitFullscreenIcon />
                        ) : (
                            <FullScreenIcon />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
